import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import SocialProofTrusted from 'src/app/organisms/Homepage/SocialProofTrusted/SocialProofTrusted';

const TrustedLogos = (): JSX.Element => (
  <SectionLayout
    maxWidth='width-3xl'
    padding={['spacing-7xl', 'spacing-none']}
    paddingSm={['spacing-4xl', 'spacing-none']}
  >
    <SocialProofTrusted />
  </SectionLayout>
);

export default TrustedLogos;
